import React from 'react';
import SchemeTreeForm from './SchemeTree/SchemeTreeForm';
import './style.scss';

class ChannelSchemes extends React.PureComponent {
  render() {
    const {
      channel,
      loading,
      channelId,
      allSchemes,
      allInsurers,
      channelSchemes,
    } = this.props;

    if (loading || !channelSchemes) {
      return <div />;
    }

    return (
      <div>
        <hr id="first-row" />
        <h4 className="title-campaign">Schemes</h4>
        {allInsurers.length > 0 && (
          <SchemeTreeForm
            channel={channel}
            channelId={channelId}
            allSchemes={allSchemes}
            allInsurers={allInsurers}
            channelSchemes={channelSchemes}
          />
        )}
      </div>
    );
  }
}

export default ChannelSchemes;
